export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重复操作"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作历史"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["账户列表"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未知错误"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["模板"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我的资产"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["有关新资产的信息"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["附加问题"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回资产"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["链接到区块链"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看过去的交易"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更改资产详情"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发行更多资产"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["编辑加密资产"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["处理中"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理您的账户"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payout could not be completed"])}
}